import { MetricDaily, MetricMonthly } from "callable-data-objects";
import { useOrganisation } from "Hooks/Endpoints";
import {
  APIOrganisationChargeContext,
  APIOrganisationMetricsContext,
} from "Providers/APIContexts";
import React, { useState } from "react";
import { APIOrganisationProps, DefaultProviderProps } from "./types";
import moment from "moment";
import { useAPI } from "./APIProvider";

const APIOrgMetricsProvider = ({ children }: DefaultProviderProps) => {
  const api = useAPI();
  const { organisation }: APIOrganisationProps = useOrganisation();
  const [dailyMetrics, setDailyMetrics] = useState<MetricDaily[]>([]);
  const [monthlyMetrics, setMonthlyMetrics] = useState<MetricMonthly>();

  React.useEffect(() => {
    const now = moment();
    if (organisation) {
      api.organisationService
        .metricMonthly(organisation.id)
        .getMonth(now.format("yy"), now.format("MM"))
        .then((resp: MetricMonthly) => {
          setMonthlyMetrics(resp);
        });

      api.organisationService
        .metricDaily(organisation.id)
        .getMonth(now.format("yy"), now.format("MM"))
        .then((resp: MetricDaily[]) => {
          setDailyMetrics(resp);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organisation]);

  return (
    <APIOrganisationMetricsContext.Provider
      value={{
        organisation,
        monthlyMetrics,
        dailyMetrics,
      }}
    >
      {children}
    </APIOrganisationMetricsContext.Provider>
  );
};

export default APIOrgMetricsProvider;
